.settings {
  position: relative;
  height: 100%;
}

/* Gear trigger button — same style as other control buttons */
.triggerBtn {
  composes: controlBtn from '../styles/controls.module.css';
}

.triggerBtn > span {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.triggerBtn > span svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.triggerBtn:hover {
  background-color: var(--color\/button\/opacity-button-hover, rgba(68,83,126,0.75));
  color: var(--color\/text\/text-primary, #fff);
}

.triggerBtn:focus-visible {
  outline: 2px solid var(--color\/text\/link-default, #75adfc);
  outline-offset: -2px;
}

/* Panel popup — hidden by default, shown when .open */
.panel {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  width: 228px;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 4px;
  z-index: 10;
  overflow: hidden;
  height: var(--active-pane-height, auto);
  transition: height 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.open .panel {
  display: block;
}

/* Sliding two-pane track */
.viewTrack {
  display: flex;
  align-items: flex-start;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

.viewTrack.onQuality {
  transform: translateX(-50%);
}

.viewPane {
  width: 50%;
  flex-shrink: 0;
  min-width: 0;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--spacing\/half, 4px);
}

/* Shared option row layout — used for debug + hotkeys */
.row {
  display: flex;
  align-items: center;
  gap: var(--spacing\/1, 8px);
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  cursor: pointer;
}

.row:hover {
  background-color: rgba(49, 75, 153, 0.5);
}

.icon {
  width: 24px;
  height: 24px;
  color: var(--color\/text\/text-primary, #fff);
}

.icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  min-width: 1px;
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  line-height: 0;
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
  overflow: hidden;
}

.labelText {
  display: block;
  line-height: 1.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

/* Empty spacer to align rows without a right-side widget */
.iconSlot {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}
